import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-17',
  templateUrl: './17.component.html',
  styleUrls: ['./17.component.scss'],
})
export class CuiGeneral17Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
